import $ from 'jquery';
window.$ = window.jQuery = $;
require('slick-carousel');
require('./inview');
require('./parallax');
require('./videomodal');
require('./main');
require('./recipes');